import { render } from "./IncidentsList.vue?vue&type=template&id=554ac5e6&ts=true"
import script from "./IncidentsList.vue?vue&type=script&lang=ts"
export * from "./IncidentsList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__